//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required, email } from 'vuelidate/lib/validators'

export default {
  name: 'LoginForm',
  props: {
    isInline: {
      type: Boolean,
      default: true
    },
    isClientLogin: {
      type: Boolean,
      default: false
    },
    isFullWidth: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    isShowCart: {
      type: Boolean,
      default: false
    },
    loginAndCheckout: {
      type: Boolean,
      default: false
    },
    clientSlugs: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      latestArticle: null,
      login: {
        email: null,
        password: null
      },
      error: null,
      loading: false,
      submitted: false,
      success: false,
      availableClients: [],
      selectedClientId: null
    }
  },
  validations: {
    login: {
      email: { required, email },
      password: { required }
    }
  },
  computed: {
    currentBreakPoint() {
      return this.$store.get('app/currentBreakPoint') || 'md'
    },
    cartItems() {
      return this.$store.get('cart/items') || null
    },
    cartTotal() {
      return this.cartItems.map((x) => x.quantity).reduce((a, b) => a + b, 0)
    },
    account() {
      return this.$store.get('user/user') || null
    },
    language() {
      return this.$store.get('language/locale') || 'en'
    }
  },
  async mounted() {
    this.loading = true
    this.clear()

    if (this.account && this.isClientLogin) {
      await this.getAvailableClient()
      if (this.availableClients.length === 1) {
        this.$router.replace({
          path: this.language === 'en' ? this.availableClients[0].slug : '/nld' + this.availableClients[0].slug
        })
        this.availableClients = null
        return
      }
    }

    this.loading = false
  },
  methods: {
    async onLoginSubmit() {
      this.submitted = true

      this.$v.login.$touch()
      if (this.$v.login.$invalid) {
        this.$nextTick(() => {
          const el = document.querySelector('#login-form input.is-danger')
          if (el) el.focus()
        })
        return false
      }

      try {
        this.loading = true
        await this.$auth.login(
          'password',
          {
            username: this.login.email,
            password: this.login.password
          },
          true
        )

        if (this.isClientLogin && this.clientSlugs) {
          await this.getAvailableClient()
          if (this.availableClients.length === 1) {
            this.$router.replace({
              path: this.language === 'en' ? this.availableClients[0].slug : '/nld' + this.availableClients[0].slug
            })
            this.availableClients = null
          } else {
            this.clear()
          }
        }

        this.$emit('userLoggedIn')
      } catch (error) {
        this.error = error.message
      } finally {
        this.loading = false
      }
    },
    async getAvailableClient() {
      const response = await this.$axios.$get(`${this.$config.apiRestUrl}/client/GetUsersClients`)
      this.availableClients = response
        .filter((x) => this.clientSlugs.map((y) => y.clientId).includes(x.idCompany))
        .map((x) => ({
          clientId: x.idCompany,
          name: x.name,
          slug: this.clientSlugs.filter((y) => y.clientId === x.idCompany)[0].slug
        }))
    },
    async onProviderSignIn(provider) {
      try {
        this.loading = true
        await this.$auth.login(provider, {
          locale: this.$store.get('language/locale') || 'en'
        })

        this.$emit('userLoggedIn')
      } catch (error) {
        this.error = this.handleError(error)
      } finally {
        this.loading = false
      }
    },
    onSelectClient() {
      const selectedClient = this.availableClients.find((x) => x.clientId === this.selectedClientId)
      if (!selectedClient) {
        return
      }
      const slug = selectedClient.slug
      this.$router.replace({ path: this.language === 'en' ? slug : '/nld' + slug })
    },
    clear() {
      this.login = {
        email: null,
        password: null
      }
      this.error = null
      this.loading = false
      this.submitted = false
      this.success = false
    },
    onOpenCart() {
      this.$emit('close')
      this.openCart(true)
    }
  }
}
